import styled from "styled-components";
import useOrderContext from "../../../../contexts/order/useOrderContext";
import React, {useState, useEffect, useRef} from "react";
import { Loader } from "@googlemaps/js-api-loader";
import useOperatorContext from "../../../../contexts/operator/useOperatorContext";


const Delivery = () => {


    const operatorContext = useOperatorContext();
    const orderContext = useOrderContext();



    // useEffect(()=>{
    //     if(ref.current && !map){
    //         setMap(new window.google.maps.Map(ref.current, {
    //             center: {lat: 4.4333479181711075, lng:-75.21505129646759},
    //             zoom: 10,
    //         }))
    //     }
    // }, [map])


    if ( !orderContext.order ) { return null;}

    const order = orderContext.order;
    const delivery = order.delivery;


    const statusString = () => {

        if ( delivery.view === 'scheduled') {
            return delivery.on_time ? 'Estimated arrival' : 'Updated arrival';
        }

        if ( delivery.view === 'enroute' ) {
            return 'Estimated arrival';
        }

        if ( delivery.view === 'delivered' ) {

            if ( delivery.left_at_door )
                return 'Delivered! (Left at door)';

            return 'Delivered!';
        }

        if ( delivery.view === 'cancelled' ) {
            return 'Order failed';
        }

        return 'Awaiting acceptance';
    };

    const timeWindow = () => {
        return delivery.view === 'cancelled'
            ? 'CANCELLED'
            : delivery.estimated;
    };

    const text = () => {

        if ( delivery.view === 'scheduled' ) {
            return 'Thanks for your order, <span>'+ order.customer.first_name +'</span>! You’ll see updates here along the way.';
        }

        if ( delivery.view === 'delivered' ) {
            return 'Enjoy your order, <span>'+ order.customer.first_name +'</span>!';
        }

        if ( delivery.view === 'enroute' ) {
            return 'Your order is on the way.';
        }

        if ( delivery.view === 'cancelled' ) {
            return 'We are sorry! Your order was not accepted and has been cancelled. You will receive an automatic refund.';
        }

        return 'Your order is waiting to be accepted. As soon as it has been it will be updated here.';
    };

    const progressText = () => {
        return delivery.on_time
            ? 'Your order’s on track to be delivered on time.'
            : 'Your order is running later than planned.';
    };

    const code = () => {
        return delivery.code;
    };

    const instructions = () => {
        return order.site.instructions ?? '';
    };

    const loader = new Loader({
        apiKey: "AIzaSyBgm0U1ZsL584MxH6SkhZzekBwK2g1ZTnM",
        version: "weekly",
    });


    let map: google.maps.Map;
    async function initMap(): Promise<void> {
        // Request needed libraries.
        //@ts-ignore
        const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
        const position = delivery.locations.driver;

        map = new Map(
            document.getElementById('map') as HTMLElement,
            {
                zoom: 14,
                center: position,
                mapId: 'ORDERSWIFT',
                disableDefaultUI: true,
                zoomControl: true,
            }
        );

        const parser = new DOMParser();

        const dropoffMarker = '<svg width="38" height="42" viewBox="0 0 38 42" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<g filter="url(#filter0_d_130_1183)">\n' +
            '<path d="M31.75 14.1665C31.75 24.0832 19 32.5832 19 32.5832C19 32.5832 6.25 24.0832 6.25 14.1665C6.25 10.785 7.5933 7.54198 9.98439 5.15089C12.3755 2.7598 15.6185 1.4165 19 1.4165C22.3815 1.4165 25.6245 2.7598 28.0156 5.15089C30.4067 7.54198 31.75 10.785 31.75 14.1665Z" fill="'+ operatorContext.operator?.theme.v3.ui.other.link +'" stroke="white" stroke-width="2.83333" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '<path d="M24.3334 20V18.6667C24.3334 17.9594 24.0525 17.2811 23.5524 16.781C23.0523 16.281 22.374 16 21.6667 16H16.3334C15.6262 16 14.9479 16.281 14.4478 16.781C13.9477 17.2811 13.6667 17.9594 13.6667 18.6667V20" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '<path d="M18.9999 13.3333C20.4727 13.3333 21.6666 12.1394 21.6666 10.6667C21.6666 9.19391 20.4727 8 18.9999 8C17.5272 8 16.3333 9.19391 16.3333 10.6667C16.3333 12.1394 17.5272 13.3333 18.9999 13.3333Z" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '</g>\n' +
            '<defs>\n' +
            '<filter id="filter0_d_130_1183" x="-2" y="0" width="42" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n' +
            '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n' +
            '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>\n' +
            '<feOffset dy="4"/>\n' +
            '<feGaussianBlur stdDeviation="2"/>\n' +
            '<feComposite in2="hardAlpha" operator="out"/>\n' +
            '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>\n' +
            '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_130_1183"/>\n' +
            '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_130_1183" result="shape"/>\n' +
            '</filter>\n' +
            '</defs>\n' +
            '</svg>';

        const dropoffMarkerSvg =
            parser.parseFromString(dropoffMarker, 'image/svg+xml').documentElement;

        const dropoff = new AdvancedMarkerElement({ map: map,
            position: delivery.locations.dropoff,
            content: dropoffMarkerSvg,
        });


        const driverMarker = '<svg width="37" height="43" viewBox="0 0 37 43" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<g filter="url(#filter0_d_130_1186)">\n' +
            '<path d="M31.5 14.75C31.5 24.6667 18.75 33.1667 18.75 33.1667C18.75 33.1667 6 24.6667 6 14.75C6 11.3685 7.3433 8.12548 9.73439 5.73439C12.1255 3.3433 15.3685 2 18.75 2C22.1315 2 25.3745 3.3433 27.7656 5.73439C30.1567 8.12548 31.5 11.3685 31.5 14.75Z" fill="black" stroke="white" stroke-width="2.83333" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '<path d="M20.97 13.5H16.5825L15.4937 15.492C15.2065 15.3708 14.8989 15.3086 14.5884 15.309C13.2685 15.3086 12.1974 16.4043 12.1943 17.758C12.1913 19.1118 13.2573 20.2126 14.5773 20.2185C15.8972 20.2244 16.9726 19.1333 16.981 17.7795C16.9812 17.6015 16.9628 17.424 16.9262 17.25H18.7763L20.97 13.5ZM20.97 13.5L21.8775 15.5775M21.8775 15.5775C22.2138 15.4001 22.5866 15.3077 22.9649 15.3083C24.1793 15.3066 25.203 16.2371 25.3473 17.474C25.4917 18.7108 24.711 19.8628 23.5304 20.1551C22.3498 20.4475 21.1427 19.7877 20.7209 18.6196C20.2991 17.4514 20.796 16.1444 21.8775 15.5775Z" stroke="white" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '<path d="M20.4447 13.7044C20.5576 13.9938 20.8837 14.1369 21.1732 14.024C21.4626 13.9111 21.6057 13.5851 21.4928 13.2956L20.4447 13.7044ZM19.5063 9.75L20.0303 9.54562C19.9461 9.32968 19.738 9.1875 19.5063 9.1875V9.75ZM18.0438 9.1875C17.7331 9.1875 17.4812 9.43934 17.4812 9.75C17.4812 10.0607 17.7331 10.3125 18.0438 10.3125V9.1875ZM18.2923 17.5389C18.4519 17.8054 18.7974 17.8922 19.0639 17.7326C19.3305 17.5731 19.4172 17.2276 19.2577 16.9611L18.2923 17.5389ZM17.6679 15.4005L17.1796 15.6797C17.1814 15.6829 17.1833 15.6862 17.1853 15.6894L17.6679 15.4005ZM16.5813 13.5L16.0786 13.7524C16.0831 13.7614 16.0879 13.7704 16.0929 13.7792L16.5813 13.5ZM15.4515 11.25L15.9542 10.9976C15.8587 10.8075 15.6642 10.6875 15.4515 10.6875V11.25ZM13.6562 10.6875C13.3456 10.6875 13.0938 10.9393 13.0938 11.25C13.0938 11.5607 13.3456 11.8125 13.6562 11.8125V10.6875ZM22.3864 15.3405C22.2555 15.0587 21.9209 14.9365 21.6392 15.0673C21.3575 15.1983 21.2352 15.5328 21.3661 15.8145L22.3864 15.3405ZM22.1536 17.5095C22.2846 17.7913 22.6191 17.9135 22.9008 17.7826C23.1826 17.6517 23.3048 17.3172 23.1739 17.0355L22.1536 17.5095ZM15.9687 15.7913C16.134 15.5283 16.0548 15.181 15.7917 15.0157C15.5287 14.8504 15.1815 14.9296 15.0162 15.1927L15.9687 15.7913ZM14.3875 17.25L13.9113 16.9507C13.8023 17.124 13.7961 17.3428 13.8952 17.5221C13.9942 17.7013 14.1828 17.8125 14.3875 17.8125V17.25ZM16.9249 17.8125C17.2356 17.8125 17.4874 17.5606 17.4874 17.25C17.4874 16.9393 17.2356 16.6875 16.9249 16.6875V17.8125ZM21.4928 13.2956L20.0303 9.54562L18.9822 9.95438L20.4447 13.7044L21.4928 13.2956ZM19.5063 9.1875H18.0438V10.3125H19.5063V9.1875ZM19.2577 16.9611L18.1505 15.1116L17.1853 15.6894L18.2923 17.5389L19.2577 16.9611ZM18.1562 15.1213L17.0696 13.2208L16.0929 13.7792L17.1796 15.6797L18.1562 15.1213ZM17.0839 13.2476L15.9542 10.9976L14.9488 11.5024L16.0786 13.7524L17.0839 13.2476ZM15.4515 10.6875H13.6562V11.8125H15.4515V10.6875ZM21.3661 15.8145L22.1536 17.5095L23.1739 17.0355L22.3864 15.3405L21.3661 15.8145ZM15.0162 15.1927L13.9113 16.9507L14.8637 17.5493L15.9687 15.7913L15.0162 15.1927ZM14.3875 17.8125H16.9249V16.6875H14.3875V17.8125Z" fill="white"/>\n' +
            '</g>\n' +
            '<defs>\n' +
            '<filter id="filter0_d_130_1186" x="-2" y="0.583496" width="42" height="42.4165" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n' +
            '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n' +
            '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>\n' +
            '<feOffset dy="4"/>\n' +
            '<feGaussianBlur stdDeviation="2"/>\n' +
            '<feComposite in2="hardAlpha" operator="out"/>\n' +
            '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>\n' +
            '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_130_1186"/>\n' +
            '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_130_1186" result="shape"/>\n' +
            '</filter>\n' +
            '</defs>\n' +
            '</svg>\n';

        const driverMarkerSvg =
            parser.parseFromString(driverMarker, 'image/svg+xml').documentElement;


        const driver = new AdvancedMarkerElement({ map: map,
            position: delivery.locations.driver,
            content: driverMarkerSvg
        });




    }


    loader
        .importLibrary('maps')
        .then(({Map}) => {
            initMap();
        })
        .catch((e) => {
            console.log('error loading gmaps', e);
        });






    //window.initMap = initMap;

    return (
        <>

            <DeliveryInfo>
                <WrapperDiv style={{ paddingBottom: '0px' }}>
                    <StatusString
                        late={!delivery.on_time && delivery.status === 'scheduled'}>{statusString()}</StatusString>
                    <Time error={delivery.view === 'cancelled'}>{timeWindow()}</Time>
                    <ProgressBarWrapper>
                        <ProgressBar completed={['enroute', 'completed'].includes(delivery.status)} active={['scheduled', 'enroute', 'completed'].includes(delivery.status)}/>
                        <ProgressBar completed={['completed'].includes(delivery.status)} active={['enroute', 'completed'].includes(delivery.status)}/>
                        <ProgressBar completed={['completed'].includes(delivery.status)} active={false}/>
                    </ProgressBarWrapper>

                    <Text dangerouslySetInnerHTML={{__html: text()}}/>

                    {delivery.view === 'scheduled' ? (
                        <ProgressText>{progressText()}</ProgressText>
                    ) : null}

                    { (delivery.view === 'scheduled' || delivery.view === 'enroute') && code().length > 0 ? (
                        <>
                            <DriverBlock>
                                <DriverInstructions>
                                    <span className={'driver-header'}>Give the rider this code</span>
                                    <span>After you’ve received your order</span>
                                </DriverInstructions>
                                <DriverCode>
                                    {code().split('').map((digit, idx) => (<span key={'digit_' + idx}>{digit}</span>))}
                                </DriverCode>
                            </DriverBlock>
                        </>
                    ) : null}
                </WrapperDiv>


                <Restaurant show={order.site.show_instructions_at_confirm && instructions().length > 0}>
                    <WrapperDiv>
                        <div className={'site-header'}>
                            <i className="feather feather-info feather-20"/>
                            <span>Restaurant note</span>
                        </div>
                        <SiteInstructions>{instructions()}</SiteInstructions>
                    </WrapperDiv>
                </Restaurant>

            </DeliveryInfo>


            {delivery.view === 'enroute' ? (
                <Map id={'map'}></Map>
            ) : null}

        </>
    );
};

const WrapperDiv = styled.div`
    padding: 20px 0;

    & > div {
        padding-left: 20px;
        padding-right: 20px;
    }


`;


const DeliveryInfo = styled.div`
    font-size: 16px;
    line-height: 24px;
    color: var(--text-black);
    border-radius: 8px;
    border: 1px solid var(--border-grey)
`;

const StatusString = styled.div<{ late: boolean }>`
    ${(props) => props.late ? 'color: #E67401;' : 'color: black;'}
`;

const Text = styled.div`
    padding-bottom: 16px;
`;


const Time = styled.div<{ error: boolean }>`
    ${(props) => props.error ? 'color: #E50000;' : 'color: var(--brand);'}

    font-size: 40px;
    line-height: 40px;
    padding: 16px 0;
`;

const ProgressBarWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;
    margin-bottom: 16px;
`;

const ProgressBar = styled.div<{ completed: boolean, active: boolean }>`

    @keyframes fillBackground {
        0% {
            background-position: 200% 0;
        }
        100% {
            background-position: -200% 0;
        }
    }
    
    height: 4px;
    flex-grow: 1;
    ${(props) => props.active ?
            'background: linear-gradient(to right, #d2d5db 0%, var(--brand) 100%);' +
            'background-size: 200% 100%;' +
            'animation: fillBackground 3s linear infinite;' : 'background-color: #d2d5db;'
    }
    ${(props) => props.completed ? 'background: var(--brand); animation: none;' : ''}
`;

const ProgressText = styled.div`
    padding: 8px 0;
    font-size: 14px;
    border-top: 1px solid var(--border-grey);
`;

const DriverBlock = styled.div`
    display: flex;
    flex-direction: row;
    padding-top: 16px;
    padding-bottom: 20px;
    border-top: 1px solid var(--border-grey);
`;
const DriverInstructions = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    
    .driver-header {
        font-weight: bold;
    }
`;



const DriverCode = styled.div`
    
    display: flex;
    flex-direction: row;
    gap: 10px;
    height: 48px;
    
    span {
        font-weight: bolder;
        font-size: 24px;
        padding: 12px 12px;
        color: var(--text-black);
        background-color: #eeeeee;
        align-content: center;
    }
`;


const SiteInstructions = styled.div`
    
`;

const Restaurant = styled.div<{show: boolean}>`
    ${(props) => props.show ? 'display: none' : ''}

    background-color: var(--bg-grey);
    border-top: 1px solid var(--border-grey);
    
    .site-header {
        display: flex;
        flex-direction: row;
        font-weight: 500;
        gap: 10px;
        padding-bottom: 12px;
    }
    
    ${(props) => !props.show ? 'display : none;' : '' }

`;

const Map = styled.div`
    
    width: 100%;
    border-radius: 8px;
    border: 1px solid var(--border-grey);
    
    height: 230px;
    background-size: cover;
    background-position: center center;

    @media screen and (min-width: 768px) {
        margin-top: 32px;
    }
    
    //img {
    //    width: 100%;
    //    max-height: 230px;
    //}
`;


export default Delivery;